
<!-- <div>
    <app-aluno-portal></app-aluno-portal>
</div>

<mat-card class="div-minhas-aulas">
    <p class="titulo-minhas-aulas">
        Ticket
    </p>
</mat-card> -->

    <mat-card class="mat-elevation-z8" style="padding: 1.5rem !important;">
        <mat-card-title>
            <button mat-icon-button color="primary" (click)="getAll()" matTooltip="Atualizar">
                <mat-icon>autorenew</mat-icon>
            </button>
            <div class="flex-fill"></div>
            <button mat-button (click)="openTicket()" color="primary">
                Novo Ticket &nbsp;
                <mat-icon>add</mat-icon>
            </button>
            <button mat-button (click)="openOcorrencia(0)" color="primary">
                Nova Ocorrência &nbsp;
                <mat-icon>add</mat-icon>
            </button>
        </mat-card-title>
        <mat-card-content>
            <div *ngIf="!error;else errorTemplate">
                <div class="loading-shade" *ngIf="isLoadingResults">
                    <mat-spinner></mat-spinner>
                </div>

                <div class="table">
                    <table mat-table [dataSource]="dataSource" style="width: 100%;">
                        <ng-container matColumnDef="protocolo">
                            <th mat-header-cell *matHeaderCellDef> Protocolo </th>
                            <td mat-cell *matCellDef="let element"> {{ element?.numeroProtocolo ? element.numeroProtocolo : '-' }} </td>
                        </ng-container>

                        <ng-container matColumnDef="assunto">
                            <th mat-header-cell *matHeaderCellDef> Assunto </th>
                            <td mat-cell *matCellDef="let element"> {{ element?.assunto ? element.assunto : '-' }} </td>
                        </ng-container>

                        <ng-container matColumnDef="dataAbertura">
                            <th mat-header-cell *matHeaderCellDef> Data da Abertura </th>
                            <td mat-cell *matCellDef="let element"> {{ element?.dataAbertura ? (element.dataAbertura | datePtBr) : '-' }} </td>
                        </ng-container>

                        <ng-container matColumnDef="dataAtendimento">
                            <th mat-header-cell *matHeaderCellDef> Data do Atendimento </th>
                            <td mat-cell *matCellDef="let element"> {{ element?.dataAtendimento ? (element.dataAtendimento | datePtBr) : '-' }} </td>
                        </ng-container>

                        <ng-container matColumnDef="sla">
                            <th mat-header-cell *matHeaderCellDef> SLA </th>
                            <td mat-cell *matCellDef="let element"> {{ element?.sla ? element.sla : '-' }} </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef> Status </th>
                            <td mat-cell *matCellDef="let element">
                                <mat-chip-list>
                                    <mat-chip [ngClass]="ajustarStatus(element.status).style">
                                        {{ ajustarStatus(element.status).label }}
                                    </mat-chip>
                                </mat-chip-list>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="responsavel">
                            <th mat-header-cell *matHeaderCellDef> Aberto Por </th>
                            <td mat-cell *matCellDef="let element"> {{ element?.usuarioResponsavel ? element.usuarioResponsavel : '-' }} </td>
                        </ng-container>

                        <ng-container matColumnDef="unidade">
                            <th mat-header-cell *matHeaderCellDef> Unidade </th>
                            <td mat-cell *matCellDef="let element"> {{ element?.aluno?.unidadeAluno ? element.aluno.unidadeAluno : '-' }} </td>
                        </ng-container>

                        <ng-container matColumnDef="rm">
                            <th mat-header-cell *matHeaderCellDef> RM </th>
                            <td mat-cell *matCellDef="let element"> {{ element?.aluno?.matricula ? element.aluno.matricula : '-' }} </td>
                        </ng-container>

                        <ng-container matColumnDef="aluno">
                            <th mat-header-cell *matHeaderCellDef> Aluno </th>
                            <td mat-cell *matCellDef="let element"> {{ element?.aluno?.nome ? element.aluno.nome : '-' }} </td>
                        </ng-container>

                        <ng-container matColumnDef="options">
                            <th mat-header-cell *matHeaderCellDef> </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="btn-options">
                                    <button *ngIf="!element.isOcorrencia" (click)="openDetalhe(element.ticketId, element.assunto)" color="primary" mat-icon-button matTooltip="Ticket">
                                        <mat-icon>search</mat-icon>
                                    </button>
                                    <button *ngIf="element.isOcorrencia" (click)="openDetalheOcorrencia(element.ticketId, element.assunto)" color="primary" mat-icon-button matTooltip="Ticket">
                                        <mat-icon>search</mat-icon>
                                    </button>
                                    <!-- <button (click)="excluir(element.ticketId)" color="warn" mat-icon-button matTooltip="Excluir" >
                                        <mat-icon>delete</mat-icon>
                                    </button> -->
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                            (click)="selection.toggle(row)" [ngClass]="{ 'selected': selection.isSelected(row) }"></tr>
                    </table>
                </div>
            </div>

            <div class="w-100" [hidden]="error">
                <mat-paginator [pageSizeOptions]="[50, 150, 100]" showFirstLastButtons></mat-paginator>
            </div>
        </mat-card-content>
    <!-- </mat-card>
</div> -->

<ng-template #errorTemplate>
    <app-server-error></app-server-error>
</ng-template>

<ng-template #loading>
    <mat-spinner [diameter]="25"></mat-spinner>
</ng-template>
